$(document).ready(function () {
    $('a.anchor-link').on('click',function(e) {
        e.preventDefault();
        var target = this.hash;
        var $target = $(target);
        jQuery('html, body').stop().animate({
            'scrollTop': $target.offset().top-120
        }, 900, 'swing', function () {});
    });
});
